import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import SignaturePad from 'signature_pad';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';

@Component({
  selector: 'app-user-signature-pad-modal',
  templateUrl: './user-signature-pad-modal.component.html',
  styleUrls: ['./user-signature-pad-modal.component.scss']
})
export class UserSignaturePadModalComponent {
  @ViewChild("myCanvasSignature", { static: true, read: ElementRef }) canvasSig: ElementRef | undefined;

  signaturePad: SignaturePad | undefined;
  signatureModel:  {
    signaturePointsString?: string ;
    signature?: string; 
  } = {};

  @Input() signatureOrInitial?: boolean;

  widthPx = 760;
  heightPx = 300;
  heightImagePx = 304;
  signaturefileName?: string;
  signatureUpload?: string;

  constructor(
    private modalRef: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private toasterNotificationService: ToasterNotificationService,
  ) { }

  ngOnInit(): void {

    if (this.canvasSig) {
      this.signaturePad = new SignaturePad(this.canvasSig.nativeElement);
    }
    if (window.innerWidth < 400) {
      this.widthPx = window.innerWidth * 0.9;
    }
  }

  close() {
    this.modalRef.close();
  }

  uploadSignature(event: any) {
    var file = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        this.signaturePad!.clear();
        this.signaturefileName = file.name;
        this.signatureUpload = reader.result.toString().split(',')[1];
      }
    }
  }

  save() {
    if (!this.signaturePad?.isEmpty()) {
        this.signatureModel.signature = this.signaturePad?.toDataURL().split(',')[1];
        this.signatureModel.signaturePointsString = "["
        this.signaturePad!.toData().forEach(result => {
          result.points.forEach(point => {
            this.signatureModel.signaturePointsString += `{"X":${point.x},"Y":${point.y},"IsEmpty":false},`
          })
        })
        this.signatureModel.signaturePointsString += "]"
        this.signatureModel.signaturePointsString = this.signatureModel.signaturePointsString?.replace(",]", "]");

      this.modalRef.close();
    } else if (this.signatureUpload) {
      this.signatureModel.signature = this.signatureUpload;
      this.modalRef.close();
    } else {
      this.toasterNotificationService.showError($localize`:@@: Please Enter a Signature.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    }
  }

  signaturePNGTransform() {
    if (this.signatureUpload) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.signatureUpload}`);
    }
    return 'assets/images/NoSignature.png';
  }

  clearSig() {
    this.signatureUpload = undefined;
    this.signaturefileName = undefined;
    this.signaturePad!.clear();
  }
}
